
// #region template categories

/**
 * List of all known Document template categories.
 * The names should contain the type of the document as well as
 * Version number or similar, to handle versions.
 */
export const DocumentTemplateCategoryNames = [
  // businessplan
  "businessplanV1",
  "businessplanWohlfahrtspflege",
  "businessplanSocialBusinesses",
  "gruenderDe",
  "gruenderplattformDe",
  "fuerGruenderDe",

  // canvas
  "sinnImpactCanvas",
  "sinnProjectCanvas",
] as const

/**
 * Type of all known document template categories.
 */
export type DocumentTemplateCategoryName = typeof DocumentTemplateCategoryNames[number]

// #endregion

// #region document categories

/**
 * Known document categories.
 *
 * DO NOT CHANGE existing category names, as they are stored in the database to recognize the category of documents.
 * Changing the name means, that Document types may not longer be recognized.
 */
export enum DocumentCategory {
  /**
   * Businessplan document categories.
   */
  Businessplan = "businessPlan",
  Canvas = "canvas",
  /**
   * Document category that does not match any other category.
   */
  Other = "other",
}

/**
 * Type guard that checks whether a given string is a valid DocumentCategory.
 *
 * @param documentCategory - The string to test.
 * @returns True if the provided string is one of the values in the DocumentCategory enum.
 *
 */
export const isDocumentCategory = (documentCategory: string): documentCategory is DocumentCategory =>
  Object.values(DocumentCategory).includes(documentCategory as DocumentCategory)

// #endregion